/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Upload_HintInputs */

const cs_chat_attach_upload_hint = /** @type {(inputs: Chat_Attach_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubory zůstanou jen v tomto chatu — stáhnout je mohou pouze členové.`)
};

const en_chat_attach_upload_hint = /** @type {(inputs: Chat_Attach_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files stay in this chat only — only members can download them.`)
};

/**
* | output |
* | --- |
* | "Files stay in this chat only — only members can download them." |
*
* @param {Chat_Attach_Upload_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_upload_hint = /** @type {((inputs?: Chat_Attach_Upload_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Upload_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_upload_hint(inputs)
	return cs_chat_attach_upload_hint(inputs)
});